import { useState } from 'react'
import { Command } from 'cmdk'
import { Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Sheet } from '@/components/ui/Sheet'
import { CurrencyCommandList } from './CurrencyList'

export function CurrencyPicker({
  open,
  onOpenChange,
  selected,
  onSelect,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  selected: string
  onSelect: (code: string) => void
}) {
  const { t } = useTranslation()
  const [query, setQuery] = useState('')
  const close = (o: boolean) => {
    onOpenChange(o)
    if (!o) setQuery('')
  }
  return (
    <Sheet open={open} onOpenChange={close} title={t('converter.select')}>
      <Command loop className="flex min-h-0 flex-1 flex-col">
        <div className="px-4 pb-2">
          <label className="flex h-12 items-center gap-2.5 rounded-xl border border-line-strong bg-surface-2 px-3.5 focus-within:border-gold-400/60">
            <Search className="size-4 text-subtle" aria-hidden />
            <Command.Input
              value={query}
              onValueChange={setQuery}
              placeholder={t('converter.search')}
              className="h-full flex-1 bg-transparent text-sm outline-none placeholder:text-subtle"
            />
          </label>
        </div>
        <Command.List className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 pb-4">
          <CurrencyCommandList
            query={query}
            selected={selected}
            onSelect={(code) => {
              onSelect(code)
              close(false)
            }}
          />
        </Command.List>
      </Command>
    </Sheet>
  )
}
